import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  allTransactionData: {},
  error: "",
  success: false,
  status: "",
};

const transformArray2ToMatchArray1 = (array2) => {
  return array2
    ?.filter(
      (item) =>
        item?.transaction?.extendedFields?.booking_status !== "APPROVED",
    )
    .map((item) => {
      const transaction = item.transaction;

      // Transform customFields to { field: [{name, value}, ...] }
      const customFields = {
        field: Object.entries(transaction.customFields || {}).map(
          ([key, value]) => ({
            name: key.toLowerCase(), // matching the lowercase key style in array1
            value: value,
          }),
        ),
      };

      // Transform extendedFields to { field: [{name, value}, ...] }
      const extendedFieldsArray = Object.entries(
        transaction.extendedFields || {},
      ).map(([key, value]) => ({
        name: key.toLowerCase(),
        value: value,
      }));

      // 🔥 Add booking_status as part of extended_fields
      extendedFieldsArray.push({
        name: "booking_status",
        value: "REJECTED",
      });

      const extendedFields = {
        field: extendedFieldsArray,
      };

      return {
        id: item.id?.toString() || "", // making id string like in array1
        number: transaction.billNumber?.toString() || "",
        type: transaction.type || "",
        user_group2_id: "0", // Default since array2 doesn't have it
        return_type: "",
        amount: transaction.billAmount?.toString() || "0.00",
        outlier_status: "NORMAL", // Default, modify if needed
        delivery_status: "DELIVERED", // Default, modify if needed
        notes: "",
        billing_time: transaction.billingDate || "",
        auto_update_time: "", // Not present in array2
        gross_amount: "0.00", // Default, can be changed
        discount: "0.00", // Default
        store: "", // Not present in array2, you can map if needed
        store_code: "", // Not present in array2
        returned_points_on_bill: "0.0",
        points: {
          issued: "0",
          redeemed: "0",
          returned: "0",
          expired: "0",
          returnedPointsOnBill: "0.0",
          expiry_date: "",
          program_id: "",
        },
        custom_fields: customFields,
        extended_fields: extendedFields,
        identifiers: {
          field: [],
        },
        coupons: [],
        basket_size: 0,
        line_items: {
          line_item: [],
        },
        reason:
          transaction.customFields?.Rejection_Reason ||
          transaction?.customFields?.Reason ||
          transaction?.comments,
      };
    });
};

const fetchAllTransactions = createAsyncThunk(
  "transaction/fetchTransactions",
  async (dates) => {
    const { startDate, endDate } = dates;
    // try {
    //   const result = await axios.get(
    //     `https://apac-apigateway.capillarytech.com/mobile/v2/api/get/customer/transactions`
    //   );
    //   return result?.data;
    // } catch (err) {
    //   console.log(err);
    // }
    try {
      // Fetch first API (Transactions)
      const transactionResult = await axios.get(
        `https://apac-apigateway.capillarytech.com/mobile/v2/api/get/customer/transactions`,
      );
      const array1 =
        transactionResult?.data?.response?.customer?.transactions
          ?.transaction || [];
      const array2 = transactionResult?.data?.data || [];
      const array3 = transformArray2ToMatchArray1(array2);
      const combinedArray = [...array1, ...array3].sort(
        (a, b) => new Date(b.billing_time) - new Date(a.billing_time),
      );

      return { transactions: combinedArray };
    } catch (err) {
      console.error(err);
      throw new Error("Failed to fetch transactions or store data.");
    }
  },
);

const allTransactionsSlice = createSlice({
  name: "transactions",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchAllTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllTransactions.fulfilled, (state, action) => {
      state.loading = false;
      state.allTransactionData = action.payload;
      state.success = action.payload?.status?.success === "true" ? true : false;
      state.error = "";
    });
    builder.addCase(fetchAllTransactions.rejected, (state, action) => {
      state.loading = false;
      state.allTransactionData = {};
      state.error = action.error.message;
    });
  },
});

export default allTransactionsSlice.reducer;
export { fetchAllTransactions };
